import React, { Suspense, useCallback } from 'react';
import Icon from 'components/Icon/Icon';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { setAccessTokenCookies, mouseflowTrack } from 'utilities/utilities_exports';
import { useSelector } from 'react-redux';

const DemoContent = () => {
  const { t } = useTranslation();
  const accountDetails = useSelector(state => state?.User?.accountDetails);
  const hasWriteAccess = useSelector(state => state?.Account?.hasWriteAccess);

  const switchToDemo = useCallback(async accountDetails => {
    if (hasWriteAccess) {
      mouseflowTrack(
        {
          username: accountDetails?.userDetails?.name || '',
          email: accountDetails?.userDetails?.SELLinALLId || '',
          storeCode: accountDetails?.merchantID || '',
          isDemoAccount: !hasWriteAccess
        },
        'ACCESS_DEMO_ACCOUNT_BUTTON_CLICKED'
      );
    }
    let accessToken = Cookies.get('accessToken');
    let refershToken = Cookies.get('refreshToken');
    if (Cookies.get('oldAccessToken') && Cookies.get('oldRefershToken')) {
      let oldAccessToken = Cookies.get('oldAccessToken');
      let oldRefershToken = Cookies.get('oldRefershToken');
      setAccessTokenCookies(
        oldAccessToken,
        oldRefershToken,
        accessToken,
        refershToken,
        accountDetails?.timeCreated,
        accountDetails?.merchantID
      );
    }
    window.location.replace('/connect');
  }, []);

  const findDate = accountDetails => {
    if (Cookies.get('timeCreated')) {
      // Convert epoch seconds to milliseconds and create a Date object
      const date = new Date(Number(Cookies.get('timeCreated')) * 1000);
      const sevenDaysLater = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000);

      // Extract UTC date components
      const day = String(sevenDaysLater.getUTCDate()).padStart(2, '0');
      const month = String(sevenDaysLater.getUTCMonth() + 1).padStart(2, '0');
      const year = sevenDaysLater.getUTCFullYear();

      // Format the date as "dd/mm/yyyy"
      const formattedDate = `${day}/${month}/${year}`;
      return formattedDate;
    }
  };

  return (
    <Suspense fallback={<></>}>
      <header className='c-header' style={{ backgroundColor: '#182340 ', padding: '10px 20px', color: '#fff' }}>
        <div className='header_nav text-right'>
          <div className='' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ textAlign: 'left' }}>
              {t('GRAAS_THIS_IS_DEMO_ACCOUNT_GRAAS')} ({t('GRAAS_VALID_UNTIL_GRAAS')} {findDate(accountDetails)})
              <br />
              {t('GRAAS_DEMO_ACCOUNT_CONNECT_MSG_GRAAS')}
            </div>
            <button className='c-button is-filled' onClick={() => switchToDemo(accountDetails)}>
              {t('GRAAS_CONNECT_MY_SOURCE_GRAAS')}
              <Icon name='keyboard_arrow_right' size='default' className='mr-1' />
            </button>
          </div>
        </div>
      </header>
    </Suspense>
  );
};

export default DemoContent;
